export async function getFloodZoneStatus(lat, lon) {
  try {
    const response = await fetch(`/api/floodzone?lat=${lat}&lon=${lon}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error checking flood zone status:', error);
    return {
      isFloodZone: null,
      floodZone: null,
      description: null
    };
  }
}